import { useDeleteNodeMutation } from '@thesisedu/feature-apollo-react'

export const useDeleteDirectMessageThreadMutation: typeof useDeleteNodeMutation = opts =>
  useDeleteNodeMutation({
    errorMessage: 'There was an error deleting that thread.',
    refetchQueries: ['directMessageThreads'],
    ...opts,
  })
